import React from "react";
import Popup from "devextreme-react/popup";
import { Button } from "devextreme-react/button";
import CheckBox from "devextreme-react/check-box";

const checkboxOptions = [
  "View Photo",
  "CV",
  "View Passport",
  "Full Size Photo",
  "COC",
  "Medical",
  "ID Card",
  "Relative ID",
  "Insurance",
  "Reg Form",
];

const DocumentSelector = ({ isOpen, onClose, onSubmit }) => {
  // Initialize selectedItems with "CV" and "View Passport"
  const [selectedItems, setSelectedItems] = React.useState(["CV", "View Passport"]);

  const handleToggle = (item) => {
    setSelectedItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleSubmit = () => {
    onSubmit(selectedItems); // Pass selected items
    onClose(); // Close popup
  };

  return (
    <Popup
      visible={isOpen}
      onHiding={onClose}
      title="Select Items"
      width={400}
      height={490}
      showCloseButton={true}
    >
      <div className="grid gap-3 p-4">
        {checkboxOptions.map((option) => (
          <div key={option} className="flex items-center space-x-2">
            <CheckBox 
                className="es-checkbox mb-2"
                //className="dx-checkbox-custom mb-1"
                key={option}
                value={selectedItems.includes(option)}
                onValueChanged={() => handleToggle(option)}
                text={option}
            />
            
          </div>
        ))}
      </div>

      <div className="dialog-footer" style={{ display: 'flex', justifyContent: 'center' }}>
          {/* <Button text="Cancel" onClick={onClose} className="es-button"/> */}
          <Button text="Ok" onClick={handleSubmit} className="es-button"/>
      </div>
    </Popup>
  );
};

export default DocumentSelector;
